import { render, staticRenderFns } from "./customer_allocation.vue?vue&type=template&id=17d41a38&scoped=true&"
import script from "./customer_allocation.vue?vue&type=script&lang=js&"
export * from "./customer_allocation.vue?vue&type=script&lang=js&"
import style0 from "./customer_allocation.vue?vue&type=style&index=0&id=17d41a38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d41a38",
  null
  
)

export default component.exports